import React from "react";
import { useTranslation } from "react-i18next";
import { Check, ArrowRight } from "lucide-react";
import { CTAButton } from "./CTAButton";

const accentCheck = { signal: "text-signal", gold: "text-gold", health: "text-health" };

export function PlanCard({ plan, testId }) {
  const { t } = useTranslation();
  const premium = plan.premium;
  const base = `data.plans.${plan.id}`;
  const features = t(`${base}.features`, { returnObjects: true });

  return (
    <div
      className={`relative flex flex-col h-full p-8 rounded-xl border transition-all duration-300 hover:-translate-y-1 ${
        premium ? "bg-[#0A0E17] border-gold/40 hover:border-gold/70"
          : plan.featured ? "bg-navy-700 border-signal/40 hover:border-signal/70 shadow-[0_8px_40px_rgba(0,85,255,0.12)]"
          : "bg-navy-800 border-white/10 hover:border-white/25"
      }`}
      data-testid={testId || `plan-card-${plan.id}`}
    >
      {premium && <div className="absolute -top-px -right-px w-32 h-32 bg-[radial-gradient(circle_at_top_right,_rgba(212,175,55,0.25),_transparent_70%)] rounded-xl pointer-events-none" />}
      {plan.featured && <span className="absolute top-5 end-5 text-[10px] uppercase tracking-[0.2em] font-bold text-signal">★</span>}

      <h3 className={`font-display font-bold text-2xl ${premium ? "text-gradient-gold" : "text-white"}`}>{t(`${base}.name`)}</h3>
      <p className="mt-2 text-sm text-white/55 min-h-[40px]">{t(`${base}.tagline`)}</p>

      <div className="mt-5 pt-5 border-t border-white/10">
        <p className="overline text-white/40">{t("common.bestFor")}</p>
        <p className="mt-1.5 text-sm text-white/70">{t(`${base}.bestFor`)}</p>
      </div>

      <ul className="mt-6 space-y-3 flex-1">
        {features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-sm text-white/70">
            <Check size={16} className={`mt-0.5 shrink-0 ${accentCheck[plan.accent]}`} />
            {f}
          </li>
        ))}
      </ul>

      <div className="mt-7">
        <CTAButton to={`/quote?plan=${plan.id}`} variant={premium ? "gold" : plan.featured ? "primary" : "secondary"} fullWidth testId={`plan-cta-${plan.id}`}>
          {t("common.requestQuote")} <ArrowRight size={16} className="rtl:rotate-180" />
        </CTAButton>
        <p className="mt-3 text-[11px] text-white/35 text-center leading-relaxed">{t("common.startingPrice")}</p>
      </div>
    </div>
  );
}

export default PlanCard;
